import { render, staticRenderFns } from "./ContactManageView.vue?vue&type=template&id=0b91e5d2&scoped=true&"
import script from "./ContactManageView.vue?vue&type=script&lang=js&"
export * from "./ContactManageView.vue?vue&type=script&lang=js&"
import style0 from "./ContactManageView.vue?vue&type=style&index=0&id=0b91e5d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b91e5d2",
  null
  
)

export default component.exports